import { useState } from "react";
import { api } from "./api.ts";

/**
 * 未登入落地頁：兩條路——
 *  · 登入（PocketID）→ 編輯者（只有作者，全部權限）
 *  · PIN 觀看 → 訪客（可有條件開放的對象，只有唯讀）；輸入完畢自動進入。
 */
export function Landing(props: { showPin: boolean; pinLen: number }) {
  const loginHref = "/auth/login?returnTo=" + encodeURIComponent("/");
  const [pin, setPin] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const max = props.pinLen || 12;

  async function enterWithPin(value: string) {
    setBusy(true);
    setErr(null);
    try {
      await api.guest(value);
      window.location.reload(); // 帶著訪客 cookie 重新載入 → 進入唯讀
    } catch (e) {
      setErr(String((e as Error).message));
      setPin("");
      setBusy(false);
    }
  }

  return (
    <div className="landing">
      <div className="landing__glow" aria-hidden />
      <div className="landing__inner">
        <h1 className="landing__logo">
          live, still<span className="dot">.</span>
        </h1>
        <p className="landing__lede">我的網站文章管理後台</p>
        <p className="landing__desc">
          這是管理我的 Docusaurus 網站（<span className="landing__repo">w_club</span>）blog 與文件的地方——
          看每篇的狀態、隨手編輯，確認後一鍵發表。
        </p>

        <a className="btn primary landing__cta" href={loginHref}>
          keep writing...
        </a>

        {props.showPin && (
          <>
            <div className="landing__div">
              <span>或</span>
            </div>
            <div className="landing__guest">
              <input
                id="pin"
                className="pin-code"
                inputMode="numeric"
                autoComplete="off"
                maxLength={max}
                placeholder="參觀內容架構"
                aria-label="PIN"
                value={pin}
                disabled={busy}
                aria-describedby="pin-hint"
                aria-invalid={err ? true : undefined}
                onChange={(e) => {
                  const v = e.target.value.replace(/\D/g, "").slice(0, max);
                  setPin(v);
                  if (err) setErr(null);
                  if (props.pinLen > 0 && v.length === props.pinLen) enterWithPin(v);
                }}
              />
              {/* 平常無文字；忙碌/錯誤時才顯示——但節點常駐讓 aria-live 對螢幕報讀者有效 */}
              <p
                id="pin-hint"
                className={`landing__hint ${err ? "err" : ""}`}
                role={err ? "alert" : "status"}
                aria-live={err ? "assertive" : "polite"}
              >
                {busy ? "進入中…" : err ? err : ""}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
